import { type ProfessionEnum, type UserAMLQuestionnaireUserProvidedValues } from '@capsicum/common';
import { atomWithReducer } from 'jotai/utils';

type StepValidity = {
	[stepId: string]: boolean;
};

type FormData = Omit<UserAMLQuestionnaireUserProvidedValues, 'profession' | 'spendingEstimatePerYear'> & {
	accountCreationReasons: [] | UserAMLQuestionnaireUserProvidedValues['accountCreationReasons'];
	profession?: ProfessionEnum;
	sourcesOfIncome: [] | UserAMLQuestionnaireUserProvidedValues['sourcesOfIncome'];
	spendingEstimatePerYear?: UserAMLQuestionnaireUserProvidedValues['spendingEstimatePerYear'];
};

type StateType = {
	formData: FormData;
	stepValidity: StepValidity;
};

type FormAction =
	| {
			data: Partial<FormData>;
			type: 'UPDATE_FORM_DATA';
	  }
	| { isValid: boolean; stepId: keyof (typeof initialState)['stepValidity']; type: 'UPDATE_STEP_VALIDITY' }
	| { type: 'RESET' };

const initialState = {
	formData: {
		accountCreationReasons: [],
		addressBuildingNumber: '',
		addressMunicipality: '',
		birthCity: '',
		birthCountry: '',
		birthDate: '',
		city: '',
		countryCode: '',
		estimatedAnnualIncome: 0,
		firstName: '',
		lastName: '',
		pep: false,
		profession: undefined,
		professionOther: undefined,
		region: '',
		sourceOfIncomeOther: undefined,
		sourcesOfIncome: [],
		spendingEstimatePerYear: undefined,
		street: '',
		zipCode: ''
	},
	stepValidity: {
		AccountCreationReasons: false,
		EstimatedAnnualIncome: false,
		Pep: true,
		PersonalInformation: false,
		PostalAddress: false,
		Profession: false,
		SourcesOfIncome: false,
		SpendingEstimatePerYear: false,
		TermsAndConditions: false
	}
};

const formReducer = (state: StateType, action: FormAction) => {
	switch (action.type) {
		case 'UPDATE_FORM_DATA':
			return {
				...state,
				formData: {
					...state.formData,
					...action.data
				}
			};
		case 'UPDATE_STEP_VALIDITY':
			return {
				...state,
				stepValidity: {
					...state.stepValidity,
					[action.stepId]: action.isValid
				}
			};
		case 'RESET':
			return initialState;
		default:
			return state;
	}
};

export const amlQuestionnaireReducerAtom = atomWithReducer(initialState, formReducer);
